// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Unsupported__wrapper___1Hgt_","logo":"Unsupported__logo___hWel3","container":"Unsupported__container___o-MO9","button":"Unsupported__button___jGxtJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Unsupported/Unsupported.scss
// module id = UH+s
// module chunks = 0